import { GetProfileResponse, GetConversationResponse } from './types'

export const EMPTY_PROFILE: GetProfileResponse = {
  id: '',
  name: '',
  picture: '',
  userId: ''
}

export const EMPTY_CONVERSATION: GetConversationResponse = {
  id: '',
  type: '',
  tenant: '',
  metadata: {
    owner: ''
  }
}
